// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-11-20 01:19:29 +0100 (Thu, 20 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 158411 $
//  Purpose   : tree utilities
// =============================================================================
// ---Third-party imports

// ---Framework imports
import log from 'uix/logging'
import {keys, values, dict, entries, mapItems, get, filterItems, isString} from 'ldash'

// ---Globals

// node id seperator with two important properties
// a) handled by route-matcher, b) is not allowed in domain names
export const SEP = '~'

export const ROOT_ID = 'NULL'

// build node ids
export const ID = (...segments) => segments.join(SEP)

export let dummyChildren = ({done}) => null

export const getExpansionState = (loaded, empty) => {
  /* get loaded + children tree node property
   */
  let children = undefined
  if (!loaded && !empty) {
    children = dummyChildren
  }
  return {loaded, children}
}

export const getTreeTplClasses = classCfgs =>
  mapItems(classCfgs, className => className, (className, clscfg) => clscfg.layout === 'L131Split')

export const isSlimLinkId = id => isString(id) && /^sl\d+_\d+$/.test(id)
